import isObjectLike_default from "./isObjectLike.js";
import _getTag_default from "./_getTag.js";

//#region ../../node_modules/lodash-es/_baseIsSet.js
/** `Object#toString` result references. */
var setTag = "[object Set]";
/**
* The base implementation of `_.isSet` without Node.js optimizations.
*
* @private
* @param {*} value The value to check.
* @returns {boolean} Returns `true` if `value` is a set, else `false`.
*/
function baseIsSet(value) {
	return isObjectLike_default(value) && _getTag_default(value) == setTag;
}
var _baseIsSet_default = baseIsSet;

//#endregion
export { _baseIsSet_default as default };
//# sourceMappingURL=_baseIsSet.js.map